import React, { memo, useEffect, useRef, useState, useMemo } from "react";
import { Accordion, Card, Row, Col } from "react-bootstrap";
import { usePrevious } from "shared/hooks";
import "./TravelLinesAccordion.styles.css";
import { ROLES } from "shared/config";

function TravelLinesAccordion({ children, defaultAllOpen = false, userRole }) {
  const bottomRef = useRef(null);

  const defaultActiveAccordionItems = useMemo(
    () => (defaultAllOpen ? children?.map((_, idx) => idx.toString()) : ["0"]),
    [children, defaultAllOpen]
  );

  const [activeAccordionItems, setActiveAccordionItems] = useState(
    defaultActiveAccordionItems
  );

  const handleAccordionClick = (idx) => {
    if (!activeAccordionItems.includes(idx)) {
      setActiveAccordionItems((prev) => [...prev, idx]);
    } else {
      setActiveAccordionItems((prev) => prev.filter((key) => key !== idx));
    }
  };

  const prevCount = usePrevious(React.Children.count(children));

  useEffect(() => {
    const currentCount = React.Children.count(children);
    let timeout;
    // @ts-ignore
    if (prevCount < currentCount) {
      clearTimeout(timeout);
      // @ts-ignore
      setActiveAccordionItems((prev) => [...prev, prevCount.toString()]);
      timeout = setTimeout(
        () =>
          bottomRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          }),
        400
      );
    }
  }, [children]);

  return (
    <>
      {userRole === ROLES.ACCOUNTS_PAYABLE && (
        <Card
          className="details-container__card pb-0 pt-4"
          style={{ marginBottom: "-0.5rem" }}
        >
          <Row lg={2} className="mb-3">
            <Col md>
              <h2 className="fs-3 mt-3 mb-4">Travel Legs</h2>
            </Col>
          </Row>
        </Card>
      )}
      <Accordion activeKey={activeAccordionItems}>
        {React.Children.map(children, (child, idx) => (
          <Accordion.Item eventKey={idx.toString()} key={child.id}>
            <Accordion.Button
              as="div"
              className="accordion-item-header"
              onClick={() => handleAccordionClick(idx.toString())}
            >
              <div className="bg-primary text-light accordion-item-header__circle">
                {idx + 1}
              </div>
              <div className="accordion-item-header__body">
                {child.props.accordionHeader}
              </div>
            </Accordion.Button>
            <div className="accordion-body-container">
              <div className="border border-3 border-primary accordion-item__vertical-line" />

              <Accordion.Body>{React.cloneElement(child)}</Accordion.Body>
            </div>
          </Accordion.Item>
        ))}
        <span ref={bottomRef} />
      </Accordion>
    </>
  );
}

export default memo(TravelLinesAccordion);
